import { render } from "./ScoreProgram.vue?vue&type=template&id=a8fa8972&scoped=true"
import script from "./ScoreProgram.vue?vue&type=script&lang=js"
export * from "./ScoreProgram.vue?vue&type=script&lang=js"

import "./ScoreProgram.vue?vue&type=style&index=0&id=a8fa8972&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8fa8972"]])

export default __exports__